// node modules
import React, { PureComponent } from 'react';
import { fieldPropTypes } from 'redux-form';

class Hidden extends PureComponent {
  static propTypes = {
    ...fieldPropTypes,
  };

  render() {
    const {
      input,
      meta: { form },
    } = this.props;
    const id = `${form}-${input.name}`;

    return <input type="hidden" id={id} {...input} />;
  }
}

export default Hidden;
